import AboutUs from "pages/shared/Company/AboutUs";
import Privacy from "pages/shared/Company/Privacy";
import TnC from "pages/shared/Company/TnC";
import Quality from "pages/shared/Company/Quality";
import Operational from "pages/shared/Company/Operational";
import AppPrivacy from "pages/shared/Company/AppPrivacy";

import ContactUs from "pages/shared/HelpSupport/ContactUs";
import FAQ from "pages/shared/HelpSupport/FAQ";

const sharedRoutes = [
  {
    name: "Company",
    icon: "source_environment",
    collapse: [
      { name: "About Us", route: "/about-us/", component: <AboutUs /> },
      { name: "Privacy Policy", route: "/privacy/", component: <Privacy /> },
      { name: "App Privacy Policy", route: "/app-privacy/", component: <AppPrivacy /> },
      { name: "Terms & Conditions", route: "/tnc/", component: <TnC /> },
      { name: "Quality Policy Statement", route: "/quality/", component: <Quality /> },
      {
        name: "Operational Roles & Responsibilities",
        route: "/operational/",
        component: <Operational />,
      },
    ],
  },
  {
    name: "Help & Support",
    icon: "call",
    collapse: [
      { name: "Contact Us", route: "/contact-us/", component: <ContactUs /> },
      { name: "FAQ", route: "/faq/", component: <FAQ /> },
    ],
  },
];

export default sharedRoutes;
